export const iconFontAwesomeEditingPenRuler = (
	<i className="fa-solid fa-pen-ruler"></i>
);
